import { render, staticRenderFns } from "./PrintLabTest.vue?vue&type=template&id=4a1001e7&scoped=true"
import script from "./PrintLabTest.vue?vue&type=script&lang=js"
export * from "./PrintLabTest.vue?vue&type=script&lang=js"
import style0 from "./PrintLabTest.vue?vue&type=style&index=0&id=4a1001e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1001e7",
  null
  
)

export default component.exports